import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Theme, TextField, InputAdornment, Icon } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import SearchIcon from 'common/assets/icons/icon-search-outline.svg';
import Container from 'common/components/Container';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	inputValue: string;
	onInputChange: (newInput: string) => void;
	onSearchClick: () => void;
}

type InputEventType = React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>;

type Props = OwnProps & WithStyles<typeof styles>;

export const RentalSearchBarForCompleted = ({ ...props }: Props) => {
	const classes = props.classes;
	const noSearchString = props.inputValue === '';
	const { t } = useTranslation();

	const label = t('rentals.search.byNameOrReferenceId', 'Search by name or code');

	const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		props.onSearchClick();
	};

	return (
		<form onSubmit={submitSearch}>
			<Container
				classes={{
					root: classes.containerRoot,
				}}
			>
				<Grid container alignItems="center" spacing={0}>
					<Grid item xs={true}>
						<TextField
							variant="standard"
							className={classes.input}
							fullWidth
							placeholder={label}
							value={props.inputValue}
							onChange={(e: InputEventType) => props.onInputChange(e.target.value)}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Icon className={classes.iconSize}>
											<img className={classes.icon} src={SearchIcon} alt={''} />
										</Icon>
									</InputAdornment>
								),
								inputProps: {
									'data-qa': 'searchField',
								},
							}}
						/>
					</Grid>
					<Grid item xs={false}>
						<Button
							color="primary"
							variant="contained"
							className={classes.btn}
							disabled={noSearchString}
							fullWidth
							type="submit"
						>
							{t('common:actions.search')}
						</Button>
					</Grid>
				</Grid>
			</Container>
		</form>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		btn: {
			width: '120px',
			marginLeft: theme.spacing(1),
		},
		input: {
			paddingTop: theme.spacing(1),
		},
		containerRoot: {
			paddingTop: theme.spacing(3),
			paddingBottom: 0,
		},
		iconSize: {
			width: theme.spacing(3),
			height: theme.spacing(3),
		},
		icon: {
			position: 'relative',
			top: '-4px',
			left: '4px',
			width: '16px',
			height: '16px',
		},
	});

export default withStyles(styles)(RentalSearchBarForCompleted);
